// 沿線・駅から探すモーダル
const ModalSearchConditions = {
  namespaced: true,

  state: {
    modal: false,
  },
  getters: {
    getModal: state => {
      return state.modal
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
  },
  actions: {},
}

export default ModalSearchConditions
